import React from 'react'
import MuiAutocomplete, { AutocompleteProps } from '@mui/material/Autocomplete'

export type { AutocompleteProps }

export const Autocomplete = <T, Multiple extends boolean, DisableClearable extends boolean, FreeSolo extends boolean, ChipComponent extends React.ElementType = "div">(props: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo, ChipComponent>) => <MuiAutocomplete {...props} />

export default Autocomplete
